module.exports = __webpack_public_path__ + "img/bigX.03919015.svg";